import * as React from 'react';
import { useSelector } from '../../../utils/useSelector';
import { useActions } from '../viewActions';
import { EmployeeSelectModal } from '../../EmployeeSelectModal/employeeSelectModal';

interface Props {
  onClose: () => any;
}

export const ActAsModal = ({ onClose }: Props) => {
  const { setActingAs } = useActions();
  const actingAs = useSelector(s => s.view?.actingAs);
  const [selected, setSelected] = React.useState(actingAs);
  return (
    <EmployeeSelectModal
      header="Act As Menu"
      description="Please enter who to act as:"
      onClose={onClose}
      selected={selected}
      onSelect={setSelected}
      onContinue={() => {
        setActingAs(selected);
        if (onClose) onClose();
      }}
    />
  );
};

export const ViewAsModal = ({ onClose }: Props) => {
  const { setViewingAs } = useActions();
  const viewingAs = useSelector(s => s.view?.viewingAs);
  const [selected, setSelected] = React.useState(viewingAs);

  return (
    <EmployeeSelectModal
      header="View As Menu"
      description="Please enter who to view as:"
      onClose={onClose}
      selected={selected}
      onSelect={setSelected}
      onContinue={() => {
        setViewingAs(selected);
        if (onClose) onClose();
      }}
    />
  );
};
